import io from 'socket.io-client';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import Actions from '../redux/actions/index';
import Constants, { CONSTANTS, SOCKET_IO_PATH, SOCKET_URL } from '../utils/Constants';
import CallNotification from '../component/CallNotification'
import StoreHistoryItem from '../component/StoreHistoryItem'
import StoreQueueCard from '../component/StoreQueueCard'
// import attentionbell from "../assets/sound/attentionbell.wav"
import classicTone from '../assets/sound/classic-tone.mp3'
import Alert from '../component/alert/alert';
import PaginationComponenent from '../component/Pagination';
import { LIMIT } from '../utils/Constants';
import Avatar from 'react-avatar';
import AppLoader from '../utils/AppLoader';
import { logoutAgentSession } from '../utils/service/logoutSession';

const HISTORY_DATE_FILTERS = [
  { key: 'all', labelKey: 'HISTORY_DATE_ALL' },
  { key: 'today', labelKey: 'HISTORY_DATE_TODAY' },
  { key: 'yesterday', labelKey: 'HISTORY_DATE_YESTERDAY' },
  { key: 'this_week', labelKey: 'HISTORY_DATE_THIS_WEEK' },
  { key: 'this_month', labelKey: 'HISTORY_DATE_THIS_MONTH' },
];

class StoreManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      callerList: [],
      curDateTime: new Date().toLocaleString(),
      tab: 0,
      callNotification: false,
      callDetails: [],
      latestCall: {},
      logoutModal: false,
      historypageNumber: 1,
      callPageNumber: 1,
      callMute: false,
      isLoading: false,
      isSrmIpAgent: 0,
      historyFilter: 'all',
      datePreset: 'all',
    }
  }
  audio = new Audio(classicTone);

  removeCallDetailByRoomId = (callDetails, roomId) => {
    if (!Array.isArray(callDetails) || roomId == null) return callDetails || [];
    return callDetails.filter((call) => call?.roomId !== roomId);
  }

  componentDidUpdate(prevProps, prevState) {
    const { callNotification } = this.state;
    if (callNotification && !prevState.callNotification) {
      if (this._notificationHideTimer) {
        clearTimeout(this._notificationHideTimer);
      }
      this._notificationHideTimer = setTimeout(() => {
        this.setState({ callNotification: false, callMute: false, callDetails: [] })
        this.audio.pause();
        this.audio.currentTime = 0;
      }, 20000)//20 sec
    }
  }

  componentDidMount() {
    // Always reload from page 1 with clear filters when entering this screen
    this.setState({
      historypageNumber: 1,
      callPageNumber: 1,
      historyFilter: 'all',
      datePreset: 'all',
    });
    const { getLoginDetails = {} } = this.props
    const { tokenDetails = {} } = getLoginDetails
    const isSrmIpAgent = tokenDetails?.userDetails?.VendorAgent?.isSrmIpAgent
    let params = {
      limit: LIMIT,
      pageNumber: 0,
      isSrmIpAgent: isSrmIpAgent
    }
    const callBack = (response) => {
      // this.props.appendQueueList(response?.response?.calls)
      this.setState({ callerList: response?.response, isSrmIpAgent: isSrmIpAgent })
    }
    this.props.customerCallListAction(params, callBack)
    if (window.location.hostname === 'localhost') {
      this.socketURL = SOCKET_URL;
    } else {
      this.socketURL = SOCKET_URL;
    }
    const socket = io(this.socketURL, { path: SOCKET_IO_PATH, transports: ['websocket'] });
    this.socket = socket;

    socket.on(`call_request/${this.props.getLoginDetails?.tokenDetails?.user?.id}`, (response) => {
      this.fetchCallQueue()
      const incoming = response?.data
      const roomId = incoming?.roomId
      this.setState((prev) => {
        const withoutDup = roomId
          ? prev.callDetails.filter((c) => c?.roomId !== roomId)
          : prev.callDetails
        return {
          callNotification: true,
          callDetails: incoming ? [...withoutDup, incoming] : withoutDup,
        }
      })
      this.audio.play();
    })
    socket.on(`call_decline/${this.props.isCustomer === 'customer' ? 'customer' : 'store'}`, (response) => {
      const roomId = response?.roomId
      this.setState((prev) => ({
        callDetails: this.removeCallDetailByRoomId(prev.callDetails, roomId),
        callNotification: this.removeCallDetailByRoomId(prev.callDetails, roomId).length > 0,
        callMute: false,
      }))
      this.fetchCallQueue()
      this.audio.pause();
      this.audio.currentTime = 0;
    })

    socket.on('remove_calls', (response) => {
      const roomId = response?.roomId
      this.setState((prev) => {
        const nextDetails = this.removeCallDetailByRoomId(prev.callDetails, roomId)
        return {
          callDetails: nextDetails,
          callNotification: nextDetails.length > 0,
          callMute: false,
        }
      })
      this.audio.pause();
      this.audio.currentTime = 0;
      this.fetchCallQueue()
    })
  }

  componentWillUnmount() {
    if (this._notificationHideTimer) {
      clearTimeout(this._notificationHideTimer);
    }
    if (this.socket) this.socket.disconnect();
  }
  openLink = (link) => {
    window.open(link, "_blank")
  }

  joinNow = (call, index, notification) => {
    const callerList = this.props.getCustomerCallList?.customerCallList?.calls
    let params = {
      roomId: notification ? call?.roomId : callerList[index]?.roomId,
      callStatus: 2,
      isActive: true,
      callStartTime: new Date().getTime(),
      isSrmIpAgent: this.state.isSrmIpAgent
    }
    let result = callerList?.find(item => item?.roomId == params?.roomId)
    localStorage.setItem("srm_ip_room", result?.SrmIpRoomServiceMapping?.SrmIpRoom?.encryptRoomId)
    const roomId = params.roomId
    const isKiosk = notification ? call?.isCallFromKiosk : result?.isCallFromKiosk
    // Open call UI immediately — do not wait for attend API (hospital latency)
    if (roomId) {
      if (isKiosk) {
        this.openLink('/kiosk_srm/manager/' + roomId)
      } else {
        this.openLink('/manager/' + roomId)
      }
    }
    this.setState({ callNotification: false })
    this.audio.pause();
    this.audio.currentTime = 0;
    const acceptCallback = (response) => {
      if (response.response_code === 0) {
        this.fetchCallQueue()
        this.setState((prev) => ({
          callDetails: this.removeCallDetailByRoomId(prev.callDetails, response?.response?.roomId),
        }))
      } else {
        this.fetchCallQueue()
      }
    }
    this.props.updateAppointment(params, acceptCallback)
    if (callerList.length >= 1) {
      return this.removeCalls(call)
    }
  }

  removeCalls = (call) => {
    let params = {
      roomId: call?.roomId,
      name: call?.User?.fullName,
      date: new Date(),
      isSrmIpAgent: this.state.isSrmIpAgent
    }
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ url: `remove_calls`, response: params, triggerFrom: "front End" })
    };
    fetch(`${this.socketURL}/api/socket`, requestOptions)
      .then(response => response.json())
      .then(data => {
        console.log(data)
      });

  }

  rejectNow = (call, index, notification) => {
    const callerList = this.props.getCustomerCallList?.customerCallList?.calls
    const targetCall = notification ? call : callerList?.[index]
    let params = {
      roomId: notification ? call.roomId : callerList[index]?.roomId,
      callStatus: 3,
      isActive: false,
      callEndTime: new Date().getTime(),
      isSrmIpAgent: this.state.isSrmIpAgent
    }


    const declinecallback = (response) => {
      this.setState({ isLoading: false })
      if (response.response_code === 0) {
        const roomId = response?.response?.roomId
        this.setState((prev) => ({
          callDetails: this.removeCallDetailByRoomId(prev.callDetails, roomId),
          callNotification: false,
        }))
        this.fetchCallQueue()
        this.audio.pause();
        this.audio.currentTime = 0;
      } else {
        this.fetchCallQueue()
        this.audio.pause();
        this.audio.currentTime = 0;
        this.setState({ callNotification: false })
      }
    }
    this.setState({ isLoading: true })
    this.props.updateAppointment(params, declinecallback)
    // Stop ringing on other agents (mobile) immediately
    if (targetCall?.roomId) {
      this.removeCalls(targetCall)
    }
  }


  callMute = () => {
    this.setState({ callMute: !this.state.callMute })
    if (!this.state.callMute) {
      this.audio.pause();
      this.audio.currentTime = 0;
    } else {
      this.audio.play();
    }
  }


  fetchCallQueue = (showLoader = false) => {
    const params = {
      limit: LIMIT,
      pageNumber: this.state.callPageNumber - 1,
      isSrmIpAgent: this.state.isSrmIpAgent
    }
    if (showLoader) this.setState({ isLoading: true })
    const callBack = (response) => {
      this.setState({ callerList: response.response, isLoading: false })
    }
    this.props.customerCallListAction(params, callBack)
  }

  handleCallQueue = () => {
    this.setState({ tab: 0 })
    this.fetchCallQueue(true)
  }

  refreshCurrentTab = () => {
    if (this.state.tab === 0) {
      this.fetchCallQueue(true)
    } else {
      this.handleHistory()
    }
  }

  buildHistoryParams = (overrides = {}) => {
    const historyFilter = overrides.historyFilter != null ? overrides.historyFilter : this.state.historyFilter;
    const datePreset = overrides.datePreset != null ? overrides.datePreset : this.state.datePreset;
    const pageNumber = overrides.pageNumber != null ? overrides.pageNumber : this.state.historypageNumber - 1;
    return {
      pageNumber,
      limit: LIMIT,
      isSrmIpAgent: this.state.isSrmIpAgent,
      ...(historyFilter && historyFilter !== 'all' ? { historyFilter } : {}),
      ...(datePreset && datePreset !== 'all' ? { datePreset } : {}),
    };
  }

  //Function trigger the call history api and affected the isloading and tab state set the respones in the reducer
  handleHistory = () => {
    let params = this.buildHistoryParams()
    this.setState({ tab: 1, isLoading: true })
    const historyCallback = (response) => {
      this.props.callHistoryList(response)
      this.setState({ isLoading: false })
    }
    this.props.agentHistory(params, historyCallback)
  }

  setHistoryFilter = (historyFilter) => {
    if (historyFilter === this.state.historyFilter) {
      return
    }
    this.setState({ historyFilter, historypageNumber: 1, isLoading: true }, () => {
      const params = this.buildHistoryParams({ historyFilter, pageNumber: 0 })
      this.props.agentHistory(params, (response) => {
        this.props.callHistoryList(response)
        this.setState({ isLoading: false })
      })
    })
  }

  setDatePreset = (datePreset) => {
    if (datePreset === this.state.datePreset) {
      return
    }
    this.setState({ datePreset, historypageNumber: 1, isLoading: true }, () => {
      const params = this.buildHistoryParams({ datePreset, pageNumber: 0 })
      this.props.agentHistory(params, (response) => {
        this.props.callHistoryList(response)
        this.setState({ isLoading: false })
      })
    })
  }

  logout = async () => {
    this.setState({ logoutModal: false, isLoading: true })
    try {
      await logoutAgentSession(this.props.history)
    } finally {
      this.setState({ isLoading: false })
    }
  }


  onChangeHistoryHandle = (pageNumbers) => {
    let params = this.buildHistoryParams({ pageNumber: pageNumbers - 1 })
    const historyCallback = (response) => {
      this.props.callHistoryList(response, "It is from the Pagination")
      this.setState({ isLoading: false })
    }
    this.props.agentHistory(params, historyCallback)
    this.setState({ historypageNumber: pageNumbers, isLoading: true })
  }


  onChangeCallQueue = (pageNumber) => {
    let params = {
      pageNumber: (pageNumber - 1),
      limit: LIMIT,
      isSrmIpAgent: this.state.isSrmIpAgent
    }
    const callBack = (response) => {
      this.setState({ callerList: response.response, isLoading: false })
    }
    this.props.customerCallListAction(params, callBack)
    this.setState({ callPageNumber: pageNumber, isLoading: true })
  }

  render() {
    const { tab, callNotification, historypageNumber, callPageNumber, isLoading, isSrmIpAgent, historyFilter, datePreset } = this.state;
    const { getHistotyDetails, getCustomerCallList } = this.props
    const callerList = getCustomerCallList?.customerCallList?.calls
    const historysValue = getHistotyDetails?.callHistory?.historys
    const historyTotalItems = getHistotyDetails?.callHistory?.totalItems
    const queueTotalItems = getCustomerCallList?.customerCallList?.totalItems || 0
    const missedCallCount = getHistotyDetails?.callHistory?.missedCallCount
    const attenedCallCount = getHistotyDetails?.callHistory?.attenedCallCount
    const totalCallCount = Number(historyTotalItems ?? ((Number(attenedCallCount) || 0) + (Number(missedCallCount) || 0)))
    const { getLoginDetails = {} } = this.props
    const { agentName, vendorLogo, tokenDetails = {} } = getLoginDetails
    const vendorAgent = tokenDetails?.userDetails?.VendorAgent
    const employeeId = vendorAgent?.empId
    const isHeadNurse = String(vendorAgent?.srmAgentRole || '').toLowerCase() === 'head_nurse'
      || Number(vendorAgent?.isSrmServiceHead) === 1
    const isWardNurse = String(vendorAgent?.srmAgentRole || '').toLowerCase() === 'ward_nurse'
    const showEscalationTimeline = isHeadNurse || isWardNurse
    const showEmployeeId = Number(isSrmIpAgent) === 1
      && Number(vendorAgent?.isSharedPortalLogin) !== 1
      && !!String(employeeId || '').trim()
    return (
      <React.Fragment>
        <div className="store-content store-dashboard">
          <div className='dash-heading-part store-dashboard__header px-4 px-md-5 py-2'>
            <div>
              <img src={vendorLogo ? vendorLogo : require('../assets/img/proglint Transparent.png')} className="dashboard-logo" alt="logo" />
            </div>
            <div className='dropdown ms-4 store-dashboard__profile'>
              <button
                className="btn d-flex align-items-center store-dashboard__profile-btn"
                type="button"
                id="agentLogoutMenu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="text-end me-2">
                  <p className="loginName mb-0">{agentName}</p>
                  {showEmployeeId ? (
                    <p className="store-dashboard__emp-id mb-0">
                      {Constants.EMPLOYEE_ID}: {String(employeeId).trim()}
                    </p>
                  ) : null}
                </div>
                <Avatar name={agentName} round={true} color={'var(--nurse-icon-bg)'} fgColor={'var(--nurse-icon-txt)'} size='35px' />
              </button>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="agentLogoutMenu">
                <li>
                  <button
                    type="button"
                    className="dropdown-item store-dashboard__logout-item"
                    onClick={() => this.setState({ logoutModal: true })}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-box-arrow-left me-2" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z" />
                      <path fillRule="evenodd" d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z" />
                    </svg>
                    {Constants.LOGOUT || 'Logout'}
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className='row row-part store-dashboard__body'>
            <div className='col-lg-4 ps-lg-5 py-lg-4 join-card-left d-none d-lg-block'>
              <div className='card-shadow-content temp-card-img store-dashboard__hero p-4'>
                <img src={require('../assets/img/agent_dashboard.png')} className="join-bg" alt="Agent dashboard" />
                <div className="store-dashboard__hero-caption">
                  <h2>Nurse console</h2>
                  <p>Attend incoming patient calls and review your call history.</p>
                </div>
              </div>
            </div>
            <div className='col-lg-8 pe-lg-5 py-3 py-lg-4'>
              <div className='card-shadow-content store-dashboard__panel p-3 p-md-4 mt-lg-0'>
                {isLoading ? <div className="store-dashboard__list-loader"><AppLoader /></div> : null}
                <div className="store-dashboard__toolbar">
                  <div className='store-dashboard__tabs'>
                    <button
                      type="button"
                      className={`store-dashboard__tab ${tab === 0 ? "is-active" : ""}`}
                      onClick={this.handleCallQueue}
                    >
                      {Constants.CALL_IN_QUEUE}
                      {queueTotalItems > 0 ? <span className="store-dashboard__tab-badge">{queueTotalItems}</span> : null}
                    </button>
                    <button
                      type="button"
                      className={`store-dashboard__tab ${tab === 1 ? "is-active" : ""}`}
                      onClick={this.handleHistory}
                    >
                      {Constants.HISTORY}
                    </button>
                  </div>
                  <button
                    type="button"
                    className="store-dashboard__refresh"
                    onClick={this.refreshCurrentTab}
                    disabled={isLoading}
                    aria-label="Refresh"
                  >
                    <i className={`fa-solid fa-rotate-right ${isLoading ? "fa-spin" : ""}`} />
                  </button>
                </div>

                {tab === 1 ? (
                  <div className="history-date-filter">
                    <div className="history-date-filter__label">{Constants.HISTORY_DATE_FILTER}</div>
                    <div className="history-date-filter__chips">
                      {HISTORY_DATE_FILTERS.map((filter) => (
                        <button
                          key={filter.key}
                          type="button"
                          className={`history-date-chip${datePreset === filter.key ? ' is-active' : ''}`}
                          onClick={() => this.setDatePreset(filter.key)}
                        >
                          {Constants[filter.labelKey]}
                        </button>
                      ))}
                    </div>
                  </div>
                ) : null}

                {tab === 1 && (missedCallCount != null || attenedCallCount != null) ? (
                  <div className="store-dashboard__stats">
                    <button
                      type="button"
                      className={`store-dashboard__stat ${historyFilter === 'all' ? 'is-selected' : ''}`}
                      onClick={() => this.setHistoryFilter('all')}
                    >
                      <span className="store-dashboard__stat-value">{totalCallCount}</span>
                      <span className="store-dashboard__stat-label">Total</span>
                    </button>
                    <button
                      type="button"
                      className={`store-dashboard__stat ${historyFilter === 'attended' ? 'is-selected' : ''}`}
                      onClick={() => this.setHistoryFilter('attended')}
                    >
                      <span className="store-dashboard__stat-value">{attenedCallCount ?? 0}</span>
                      <span className="store-dashboard__stat-label">Attended</span>
                    </button>
                    <button
                      type="button"
                      className={`store-dashboard__stat store-dashboard__stat--missed ${historyFilter === 'missed' ? 'is-selected' : ''}`}
                      onClick={() => this.setHistoryFilter('missed')}
                    >
                      <span className="store-dashboard__stat-value">{missedCallCount ?? 0}</span>
                      <span className="store-dashboard__stat-label">Missed</span>
                    </button>
                  </div>
                ) : null}

                <div className={`store-dashboard__list feedback-contents content-scroll ${isLoading ? "is-loading" : ""}`}>
                  {
                    tab === 0 ?
                      <div className="store-list-panel">
                        {
                          callerList?.length > 0 ? callerList.map((call, index) => (
                            <StoreQueueCard
                              key={call?.roomId || index}
                              call={call}
                              index={index}
                              onJoin={this.joinNow}
                              onReject={this.rejectNow}
                            />
                          )) : (
                            <div className="store-empty-state">
                              <i className="fa-solid fa-phone-volume store-empty-state__icon" />
                              <p className="store-empty-state__title">No calls in queue</p>
                              <p className="store-empty-state__text">New patient calls will appear here automatically.</p>
                            </div>
                          )
                        }
                      </div> :
                      <div className="store-list-panel">
                        {
                          historysValue?.length > 0 ? historysValue.map((item, index) => (
                            <StoreHistoryItem
                              key={item?.id || item?.roomId || index}
                              item={item}
                              isSrmIpAgent={isSrmIpAgent}
                              showEscalationTimeline={showEscalationTimeline}
                            />
                          )) : (
                            <div className="store-empty-state">
                              <i className="fa-solid fa-clock-rotate-left store-empty-state__icon" />
                              <p className="store-empty-state__title">{Constants.NO_DATA_FOUND}</p>
                              <p className="store-empty-state__text">Your completed and missed calls will show here.</p>
                            </div>
                          )
                        }
                      </div>
                  }
                  {this.state.logoutModal && <Alert
                    id="Alert"
                    description={CONSTANTS.LOG_OUT.desc}
                    proceed={CONSTANTS.LOG_OUT.proceed}
                    cancel={CONSTANTS.LOG_OUT.cancel}
                    onSuccess={() => this.logout()}
                    onFailure={() => this.setState({ logoutModal: false })}
                  />}
                  {callNotification && <CallNotification rejectNow={(e) => this.rejectNow(e, '', true)} joinNow={(e) => this.joinNow(e, '', true)} callMute={() => this.callMute()} mute={this.state.callMute} callDetails={this.state.callDetails} />}
                </div>

                {tab === 0 && queueTotalItems > (LIMIT - 1) ? (
                  <div className="store-dashboard__footer">
                    <div className='page-content'>
                      <PaginationComponenent currentPage={callPageNumber} countValue={queueTotalItems} onChangeHandle={this.onChangeCallQueue} />
                    </div>
                  </div>
                ) : null}
                {tab === 1 && historyTotalItems > (LIMIT - 1) ? (
                  <div className="store-dashboard__footer">
                    <div className='page-content'>
                      <PaginationComponenent currentPage={historypageNumber} countValue={historyTotalItems} onChangeHandle={this.onChangeHistoryHandle} />
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export const mapStateToProps = (state) => {
  return {
    getQueueList: state?.CHAT_LIST?.queueList,
    getCustomerCallList: Actions.getCustomerCallListDetails(state),
    getHistotyDetails: Actions.getHistotyDetails(state),
    getLoginDetails: Actions.getLoginDetails(state),
    updateAppointmentLoader: state?.UPDATE_APPOINTMENT,
  }
};
export default withRouter(connect(mapStateToProps, {
  customerCallListAction: Actions.customerCallListAction,
  updateAppointment: Actions.updateAppointmentAction,
  agentHistory: Actions.callHistoryAction,
  appendQueueList: Actions.addChatQueueList,
  callHistoryList: Actions.callHistoryListAction,
})(StoreManager))
